import React from 'react';
import VerificationInput from 'react-verification-input';

export const PASSCODE_LENGTH = 6;

interface PasscodeInputProps {
  value: string;
  onChange: (value: string) => void;
  hasError: boolean;
  ariaLabel: string;
}

export const PasscodeInput = ({
  value,
  onChange,
  hasError,
  ariaLabel,
}: PasscodeInputProps) => (
  <VerificationInput
    value={value}
    onChange={onChange}
    length={PASSCODE_LENGTH}
    validChars="0-9"
    placeholder=""
    passwordMode
    autoFocus
    inputProps={{
      'aria-label': ariaLabel,
      autoComplete: 'off',
      inputMode: 'numeric',
    }}
    classNames={{
      container: 'container',
      character: hasError
        ? 'verification-character--error'
        : 'verification-character',
      characterSelected: hasError
        ? 'verification-character--selected--error'
        : 'verification-character--selected',
    }}
  />
);
